import React, {Component} from "react";
import SimpleDDL from "../../../../../../modules/SimpleDDL";
import SimpleInput from "../../../../../../modules/SimpleInput";
import SimpleCheckBox from "../../../../../../modules/SimpleCheckBox";
import FlexView from "react-flexview";
import SubTabTransaksiContent from "./subTabTransaksiContent";
import {contructQueryParam, fetchDataAsync, FormatCurrencyWithoutSymbol} from "../../../../../../Services/Utils";
import Api from "../../../../../../Services/Api";
import {mapToObjectDDL} from "../../../../../common/mapper";
import {HttpStatus} from "../../../../../common/Constants";
import SimpleLoadingOverlay from "../../../../../../modules/popup/SimpleLoadingOverlay";
import NumberFormat from "react-number-format";
import { isPriceDifferent } from "../violationRules";
import { fetchSalesProgramOptions } from "../salesProgramOptions";

class tabTransaksi extends Component {
    tabList = [
        {label: "Pembayaran Unit", value: "pembayaranUnit"},
        {label: "Data Transaksi Tambahan", value: "dataTransaksiTambahan"},
        {label: "Pembayaran Konsumen", value: "pembayaranKonsumen"},
    ];

    constructor(props) {
        super(props);
        this.user = this.props.user;
        this.marketingLine = this.user.marketingLine
        this.adminLine = this.user.administrationLine
        this.state = {
            loading: false,
            activeTab: {label: "Pembayaran Unit", value: "pembayaranUnit"},
            typeHargaUnit: {
                onTr: false,
                offTr: false,
            },
            priceUnit: null,
            dataDetail: {},
            bankOptions: [],
            taxOptions: [],
            promoOptions: [],
            salesOptions: [],
            leasingOptions: []
        }
    }

    componentDidMount = async () => {
        this.handleTriggerLoading();
        await this.fetchDataPriceUnit();
        this.fetchDataLeasing(this.props.data.kodeCabang?.value)
        let kodeCabang = this.props.data.kodeCabang?.value
        const idUser = localStorage.getItem("userId")

        const res = await Promise.all([
            fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllMasterBank,
                setError: this.props.setError,
                menuName: "Faktur Jual - Sales Order",
                args: {
                    paramFilters: {
                        kodecabang: kodeCabang ? [kodeCabang] : []
                    }
                },
            }),
            fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllBizparByParam,
                setError: this.props.setError,
                menuName: "CRM Management CDB",
                args: {paramFilters: {bizparCategory: "TAX_TYPE"}},
            }),
            fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_MASTER_DATA").getDropDownListSalesForSalesOrder,
                setError: this.props.setError,
                menuName: "CRM Management CDB",
                args: {idUser,kodeCabang:kodeCabang||''},
            }),
        ]);

        if (res[0].ok && res[0].data.status === HttpStatus.SUCCESS) {
            this.setState({
                bankOptions: res[0].data.data.map(item => mapToObjectDDL(`${item.bankName} - ${item.accountNumber}`, item.bankCode))
            })
        }

        if (res[1].ok && res[1].data.status === HttpStatus.SUCCESS) {
            this.setState({
                taxOptions: res[1].data.data.map(item => mapToObjectDDL(item.value, item.key))
            })
        }
        if (res[2].ok && res[2].data.status === HttpStatus.SUCCESS) {
            this.setState({
                salesOptions: res[2].data.data.map(item => {
                        return {
                            label: item.name,
                            value: item.employeeId,
                            marketingLevel: item.marketingLevel,
                            salesType: item.salesType !== null ? item.salesType?.key : null
                        }
                    }
                )
            })
        }

        const kodeVarian = this.props.data?.dataUnit?.kodeVariant?.value;
        const idWarna = this.props.data?.dataUnit?.idWarna?.value;
        const pembayaranUnit = this.props.data?.dataTransaction?.detailTransaction?.pembayaranUnit;
        const typePayment = pembayaranUnit?.tipePayment?.value;
        let filterPromo = {
            promoType: typePayment,
            kodeVariant: kodeVarian,
            idWarna: idWarna,
            leasingId: pembayaranUnit?.leasing?.value,
            downPayment: pembayaranUnit?.dpPo,
            tenor: pembayaranUnit?.tenor,
        }

        if (kodeVarian && idWarna && typePayment) {
            await this.fetchDataPromo(filterPromo);
        }

        this.handleTriggerLoading();
    }

    fetchDataLeasing = async (currDataCabang) => {
        const res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllMasterLeasing,
            setError: this.props.setError,
            menuName: "Faktur Jual - Sales Order",
            args: {
                paramFilters: {
                    listKodeCabang: [currDataCabang]
                }
            },
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.setState(prev => ({
                ...prev,
                leasingOptions: res.data.data.map(item => mapToObjectDDL(item.leasingName, item.leasingId))
            }))
        }
    };

    fetchDataBank = async (cabang) => {
        if (!cabang) {
            return
        }
        const res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllMasterBank,
            setError: this.props.setError,
            menuName: "Faktur Jual - Sales Order",
            args: {
                paramFilters: {
                    kodecabang: [cabang]
                }
            },
        })
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.setState({
                bankOptions: res.data.data.map(item => mapToObjectDDL(`${item.bankName} - ${item.accountNumber}`, item.bankCode))
            })
        }
    }

    fetchDataDropDownListSalesForSalesOrder = async () => {
        const idUser = localStorage.getItem("userId")
        const kodeCabang = this.props.data.kodeCabang?.value;
        const res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").getDropDownListSalesForSalesOrder,
            setError: this.props.setError,
            menuName: "Faktur Jual - Sales Order",
            args: {idUser,kodeCabang},
        })
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.setState({
                salesOptions: res.data.data.map(item => {
                        return {
                            label: item.name,
                            value: item.employeeId,
                            marketingLevel: item.marketingLevel,
                            salesType: item.salesType !== null ? item.salesType?.key : null
                        };
                    }
                )
            })
        }
    }

    componentDidUpdate = async (prevProps, prevState) => {
        const prevDataCabang = prevProps.data.kodeCabang?.value;
        const currDataCabang = this.props.data.kodeCabang?.value;

        if (prevState.dataDetail !== this.state.dataDetail) {
            const {dataDetail} = this.state;
            const {tab} = this.props;
            Object.entries(this.tabList).forEach(([_, value]) => {
                this.props.onSetState(tab, value?.value, dataDetail[value?.value]);
            });
        }

        const prevData = prevProps.data?.dataTransaction?.detailTransaction?.pembayaranUnit;
        const currData = this.props.data?.dataTransaction?.detailTransaction?.pembayaranUnit;

        const currKodeVarian = this.props.data?.dataUnit?.kodeVariant?.value;
        const currIdWarna = this.props.data?.dataUnit?.idWarna?.value;

        const prevTypePayment = prevData?.tipePayment?.value;
        const currTypePayment = currData?.tipePayment?.value;

        const prevLeasingId = prevData?.leasing?.value;
        const currLeasingId = currData?.leasing?.value;

        const prevDpPo = prevData?.dpPo;
        const currDpPo = currData?.dpPo;

        const prevTenor = prevData?.tenor;
        const currTenor = currData?.tenor;
        
        if (prevDataCabang !== currDataCabang) {
            this.fetchDataBank(currDataCabang);
            this.fetchDataDropDownListSalesForSalesOrder();
            this.fetchDataPriceUnit();
        }

        if (prevDataCabang !== currDataCabang || currTypePayment !== prevTypePayment) {
            if (currTypePayment === "CREDIT") {
                await this.fetchDataLeasing(currDataCabang);
            }
        }

        if (currTypePayment !== prevTypePayment) {
            await this.props.onSetState((prevState) => ({
                ...prevState,
                data: {
                    ...prevState.data,
                    dataTransaction: {
                        ...prevState.data.dataTransaction,
                        detailTransaction: {
                            ...prevState.data.dataTransaction.detailTransaction,
                            pembayaranUnit: {
                                ...prevState.data.dataTransaction.detailTransaction.pembayaranUnit,
                                salesProgramId: null
                            }
                        }
                    }
                }
            }));
            if (currTypePayment === "CREDIT") {
                this.props.onSetState((prevState) => ({
                    ...prevState,
                    data: {
                        ...prevState.data,
                        dataTransaction: {
                            ...prevState.data.dataTransaction,
                            detailTransaction: {
                                ...prevState.data.dataTransaction.detailTransaction,
                                pembayaranKonsumen: {
                                    ...prevState.data.dataTransaction.detailTransaction.pembayaranKonsumen,
                                    dibayarTransfer: 0,
                                    bankId: null,
                                    cashTempo: 0,
                                    tanggalDeadlineTempo: null,
                                }
                            }
                        }
                    }
                }))
            }

            this.setState((prevState) => ({
                ...prevState,
                promoOptions: [],
            }));
        }

        const hasChanged = prevTypePayment !== currTypePayment || prevLeasingId !== currLeasingId || prevDpPo !== currDpPo || prevTenor !== currTenor || prevDataCabang !== currDataCabang;
        let payment = false;
        if (currTypePayment) {
            if (currTypePayment === "CREDIT" && currLeasingId) {
                payment = true;
            } else if (currTypePayment === "CASH") {
                payment = true;
            }
        }

        const isAllPresent = currKodeVarian && currIdWarna && payment;
        if (hasChanged && isAllPresent) {
            let filterPromo = {
                promoType: currTypePayment,
                kodeVariant: currKodeVarian,
                idWarna: currIdWarna,
                leasingId: currLeasingId,
                downPayment: currDpPo,
                tenor: currTenor,
            }

            await this.fetchDataPromo(filterPromo);
        }

        const prevTipeHargaUnit = prevProps.data?.dataTransaction?.headerTransaction?.tipeHargaUnit;
        const currTipeHargaUnit = this.props.data?.dataTransaction?.headerTransaction?.tipeHargaUnit;
        
        if (prevTipeHargaUnit !== currTipeHargaUnit) {
            let jumlahHarga = 0;
            if (currTipeHargaUnit === "ON_THE_ROAD") {
                jumlahHarga = this.state.priceUnit?.onTheRoad;
            } else {
                jumlahHarga = this.state.priceUnit?.offTheRoad;
            }
            
            this.props.onSetState((prevState) => ({
                ...prevState,
                data: {
                    ...prevState.data,
                    dataTransaction: {
                        ...prevState.data.dataTransaction,
                        headerTransaction: {
                            ...prevState.data.dataTransaction.headerTransaction,
                            hargaOtrOff: jumlahHarga
                        }
                    }
                }
            }));
        }

        const currHargaOtrOff = this.props.data?.dataTransaction?.headerTransaction?.hargaOtrOff;
        const prevHargaOtrOff = prevProps.data?.dataTransaction?.headerTransaction?.hargaOtrOff;
        
        const currHargaDiberikan = this.props.data?.dataTransaction?.headerTransaction?.hargaDiberikan;
        const prevHargaDiberikan = prevProps.data?.dataTransaction?.headerTransaction?.hargaDiberikan;
        
        if (
          currHargaOtrOff !== prevHargaOtrOff ||
          currHargaDiberikan !== prevHargaDiberikan
        ) {
          this.props.handlePelanggaran(
            isPriceDifferent(currHargaDiberikan, currHargaOtrOff),
            "APPRV0008"
          );
        }
            
    }

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };

    handleValueCheckBox = (name, value) => {
        const valueStr = name === "onTr" && value ? "ON_THE_ROAD" : "OFF_THE_ROAD";
        this.props.onSetState((prevState) => ({
            ...prevState,
            data: {
                ...prevState.data,
                dataTransaction: {
                    ...prevState.data.dataTransaction,
                    headerTransaction: {
                        ...prevState.data.dataTransaction.headerTransaction,
                        tipeHargaUnit: valueStr
                    }
                }
            }
        }))
    }

    handleHeaderValueChange = (name, value) => {
        this.props.onSetState((prevState) => ({
            ...prevState,
            data: {
                ...prevState.data,
                dataTransaction: {
                    ...prevState.data.dataTransaction,
                    headerTransaction: {
                        ...prevState.data.dataTransaction.headerTransaction,
                        [name]: value,
                        ...(name === "salesPersonId" ? {levelMarketing: value?.marketingLevel} : {})
                    }
                }
            }
        }))
    }

    handleTabChange = (activeTab) => {
        this.setState((prevState) => ({
            ...prevState,
            activeTab,
        }));
    };

    handleDetailValueChange = (activeTab, name, value) => {
        this.props.onSetState((prevState) => ({
            ...prevState,
            data: {
                ...prevState.data,
                dataTransaction: {
                    ...prevState.data.dataTransaction,
                    detailTransaction: {
                        ...prevState.data.dataTransaction?.detailTransaction,
                        [activeTab]: {
                            ...prevState.data.dataTransaction?.detailTransaction?.[activeTab],
                            [name]: value
                        }
                    }
                }
            }
        }))
    }

    getValueHeader = (key) => {
        return this.props.data.dataTransaction?.headerTransaction?.[key]
    }

    getValueDetail = (tabKey, key) => {
        return this.props.data.dataTransaction?.detailTransaction?.[tabKey?.value]?.[key];
    }

    getIsValidHargaDiberikan = () => {
        const hargaOtrOff = this.getValueHeader("hargaOtrOff") || 0;
        const hargaDiberikan = this.getValueHeader("hargaDiberikan") || 0;

        
        return parseInt(hargaDiberikan) !== parseInt(hargaOtrOff);
    }

    getDataPriceUnit = () => {
        const {priceUnit} = this.state;
        const tipeHargaUnit = this.getValueHeader("tipeHargaUnit");
        let jumlahHarga = 0;
        if (priceUnit) {
            if (tipeHargaUnit === "ON_THE_ROAD") {
                jumlahHarga = priceUnit?.onTheRoad;
            } else {
                jumlahHarga = priceUnit?.offTheRoad;
            }
        }

        return jumlahHarga;
    }

    fetchDataPriceUnit = async () => {
        const kodeVarian = this.props.data?.dataUnit?.kodeVariant?.value;
        let kodeCabang = this.props.data.kodeCabang?.value;
        if (kodeVarian) {
            let res = await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_MASTER_DATA").getPriceUnitSalesOrder,
                setError: this.props.setError,
                menuName: "Faktur Jual - Paket Penjualan",
                args: contructQueryParam({
                    kodeCabang: kodeCabang,
                    kodeVariant: this.props.data?.dataUnit?.kodeVariant?.value
                }),
            });

            if (res.ok && res.data.status === HttpStatus.SUCCESS) {
                this.setState((prevState) => ({
                    ...prevState,
                    priceUnit: res.data.data
                }));

                this.props.onSetState((prevState) => ({
                    ...prevState,
                    data: {
                        ...prevState.data,
                        dataTransaction: {
                            ...prevState.data.dataTransaction,
                            headerTransaction: {
                                ...prevState.data.dataTransaction.headerTransaction,
                                hargaOtrOff: res.data.data?.onTheRoad,
                            }
                        }
                    }
                }))
            }
        }
    }

    fetchDataPromo = async (filter = {}) => {
        const kodeCabang = this.props.data.kodeCabang?.value;
        const promoOptions = await fetchSalesProgramOptions({
            kodeCabang,
            setError: this.props.setError,
            ...filter,
        });

        this.setState({ promoOptions });

    }

    checkReadonly = () => {
        const { state, headerTab } = this.props;
        if(headerTab === 'DGI'){
            return !state.isEditable
        }
        return !state.isEditableSpesificField
    };

    handleSelectNamaPenjual = (value, name) => {
        if(!value.salesType){
            this.props.onSetState(prev=>({
                ...prev,
                alertInfo: {
                  ...prev.alertInfo,
                  visible: !prev.alertInfo.visible,
                  title: "Peringatan",
                  content: "Jenis Penjual tidak ditemukan pada user ini. Default jenis penjual OFFICE digunakan"
                },
            }))
        }
        this.handleHeaderValueChange(name, value);
        this.props.onSetState({
            namaPenjual: value?.label,
        });
    }


    render() {
        let {errors} = this.props;
        return (
            <>
                <FlexView column style={{gap: 20}}>
                    <div className="grid grid-2x gap-20px grid-mobile-none">
                        <div id="grid-1">
                            <div className="margin-5px">
                                <div className="txt-site txt-11 txt-main txt-bold">
                                    <h4>Harga Unit</h4>
                                </div>
                            </div>
                            <FlexView style={{gap: 20, marginBottom: 20}}>
                                <SimpleCheckBox
                                    id="input_check_box_on_tr"
                                    name="onTr"
                                    label="On TR"
                                    disabled={!this.props.state.isEditable}
                                    checked={this.getValueHeader("tipeHargaUnit") === "ON_THE_ROAD"}
                                    onChange={({target}) =>
                                        this.handleValueCheckBox(target.name, target.checked)
                                    }
                                />
                                <SimpleCheckBox
                                    id="input_check_box_off_the_road"
                                    name="offTr"
                                    label="Off The Road"
                                    disabled={!this.props.state.isEditable}
                                    checked={this.getValueHeader("tipeHargaUnit") === "OFF_THE_ROAD"}
                                    onChange={({target}) =>
                                        this.handleValueCheckBox(target.name, target.checked)
                                    }
                                />
                            </FlexView>
                            <SimpleInput
                                id="input_text_harga_otr_off"
                                name="hargaOtrOff"
                                label="Harga OTR/Off"
                                readOnly
                                value={FormatCurrencyWithoutSymbol({number:this.getDataPriceUnit()})}
                            />
                            <FlexView column style={{justifyContent: "space-between", gap: "5px"}}>
                                <div className="txt-site txt-11 txt-main txt-bold">
                                    <h4>Harga Diberikan <span style={{color: "red"}}>*</span></h4>
                                </div>
                                <FlexView style={{justifyContent: "space-between", gap: "5px", marginBottom: "20px"}}>
                                    <NumberFormat
                                        id="input_text_harga_diberikan"
                                        disabled={!this.props.state.isEditable}
                                        thousandSeparator="."
                                        decimalSeparator=","
                                        value={FormatCurrencyWithoutSymbol({number: this.getValueHeader("hargaDiberikan")})}
                                        style={{backgroundColor: !this.props.state.isEditable && "#E6E6E6"}}
                                        type="text"
                                        className="txt txt-sekunder-color"
                                        onValueChange={({value}) => this.handleHeaderValueChange("hargaDiberikan", value)}
                                    />
                                    {this.getIsValidHargaDiberikan() && (
                                        <div className="txt-site txt-11 txt-main txt-bold">
                                            <h4 style={{color: "red"}}>Perlu Approval</h4>
                                        </div>
                                    )}
                                </FlexView>
                                {errors?.["dataTransaction"]?.hargaDiberikan && (
                                    <p className="txt-site txt-11 color-red margin-top-5px">{errors?.["dataTransaction"]?.hargaDiberikan}</p>
                                )}
                            </FlexView>
                        </div>
                        <div id="grid-2">
                            <SimpleInput
                                id="input_text_no_buku"
                                name="nomorBuku"
                                mandatory
                                label="No. Buku"
                                readOnly={this.checkReadonly()}
                                errorMessage={errors?.["dataTransaction"]?.nomorBuku}
                                value={this.getValueHeader("nomorBuku")}
                                onChange={(e) => this.handleHeaderValueChange(e.target.name, e.target.value)}
                            />
                            <SimpleInput
                                id="input_text_id_sales_program_dgi"
                                name="idSalesProgramDgi"
                                label="ID Sales Program DGI"
                                readOnly
                                value={this.getValueHeader("idSalesProgramDgi")}
                            />
                            <SimpleDDL
                                id="select_options_nama_penjual"
                                name="salesPersonId"
                                label="Nama Penjual"
                                mandatory
                                box="search"
                                isClearable
                                options={this.state.salesOptions}
                                readOnly={this.checkReadonly()}
                                errorMessage={errors?.["dataTransaction"]?.salesPersonId}
                                value={this.getValueHeader("salesPersonId")}
                                onChange={(value, {name}) => this.handleSelectNamaPenjual(value,name)}
                            />
                            <SimpleInput
                                id="input_text_level_mkt"
                                name="levelMarketing"
                                label="Level Mkt"
                                readOnly
                                value={this.getValueHeader("levelMarketing")}
                            />
                        </div>
                    </div>
                    <SubTabTransaksiContent
                        {...this.props}
                        salesOptions={this.state.salesOptions}
                        bankOptions={this.state.bankOptions}
                        taxOptions={this.state.taxOptions}
                        promoOptions={this.state.promoOptions}
                        leasingOptions={this.state.leasingOptions}
                        tabList={this.tabList}
                        activeTab={this.state.activeTab}
                        handleTabChange={this.handleTabChange}
                        getValue={this.getValueDetail}
                        onValueChange={this.handleDetailValueChange}
                    />
                </FlexView>
                {this.state.loading && <SimpleLoadingOverlay active={this.state.loading}/>}
            </>
        )
    }
}

export default tabTransaksi;
